import { useState } from "react";
import { apiUrl } from "@/shared/api";
import { Sezione } from "./parti";
import type { ContextOrder } from "./tipi";

type Item = ContextOrder["items"][number];

function ProductRow({ item }: { item: Item }) {
  const [imgError, setImgError] = useState(false);
  const thumbUrl = item.image_url ? apiUrl(`/api/orders/items/${item.id}/thumb`) : null;
  return (
    <div className="flex items-start gap-2.5">
      <div className="h-10 w-10 shrink-0 overflow-hidden rounded border border-line bg-paper">
        {thumbUrl && !imgError ? (
          <img
            src={thumbUrl}
            alt={item.title}
            loading="lazy"
            decoding="async"
            referrerPolicy="no-referrer"
            onError={() => setImgError(true)}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="grid h-full w-full place-items-center font-mono text-[8px] uppercase text-ink">
            IMG
          </div>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[12.5px] font-semibold leading-snug text-ink" title={item.title}>
          {item.title || item.sku}
        </div>
        <div className="mt-0.5 flex items-baseline gap-1.5 tabular-nums text-[11.5px] text-ink">
          <span className="truncate" title={item.sku}>
            {item.sku}
          </span>
          <span className="shrink-0 font-semibold">×{item.quantity}</span>
        </div>
      </div>
    </div>
  );
}

export function Prodotti({ items }: { items: Item[] }) {
  if (items.length === 0) return null;
  return (
    <Sezione titolo={`Prodotti (${items.length})`}>
      <div className="space-y-2.5">
        {items.map((item) => (
          <ProductRow key={item.id} item={item} />
        ))}
      </div>
    </Sezione>
  );
}
